import { createFormStore } from '#/shared/stores/createFormStore';

import type { TimesheetVerificationFormValues } from '../types/TimesheetVerificationFormValues';

export const useVerifyFormStore = createFormStore<TimesheetVerificationFormValues>('verify-form-storage');
